import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import Header from "./components/Header";
import Footer from "./components/Footer";
import HomePage from "./pages/Home";
import AboutPage from "./pages/About";
import ServicesPage from "./pages/Services";
import GalleryPage from "./pages/Gallery";
import ReviewsPage from "./pages/Reviews";
import FAQPage from "./pages/FAQ";
import ContactPage from "./pages/Contact";
import DeepCleaningPage from "./pages/DeepCleaning";
import CommercialCleaningPage from "./pages/CommercialCleaning";
import HouseCleaningPage from "./pages/HouseCleaning";
import MoveInOutCleaningPage from "./pages/MoveInOutCleaning";
import VacationRentalCleaningPage from "./pages/VacationRentalCleaning";
import ResourcesHubPage from "./pages/ResourcesHub";
import DeepCleaningGuidePage from "./pages/DeepCleaningGuide";
import PalmBayPage from "./pages/PalmBay";
import MelbournePage from "./pages/Melbourne";
import VieraPage from "./pages/Viera";
import SatelliteBeachPage from "./pages/SatelliteBeach";
import IndialanticPage from "./pages/Indialantic";
import IndianHarbourBeachPage from "./pages/IndianHarbourBeach";
import CocoaBeachPage from "./pages/CocoaBeach";
import MelbourneBeachPage from "./pages/MelbourneBeach";
import RockledgePage from "./pages/Rockledge";
import CocoaPage from "./pages/Cocoa";
import MerrittIslandPage from "./pages/MerrittIsland";
import WestMelbournePage from "./pages/WestMelbourne";
import OfficeCleaningPage from "./pages/OfficeCleaningPage";
import PropertyManagementCleaningPage from "./pages/PropertyManagementCleaningPage";
import RealEstateCleaningPage from "./pages/RealEstateCleaningPage";
import PostConstructionCleaningPage from "./pages/PostConstructionCleaningPage";
import WhyChoosePage from "./pages/WhyChoosePage";
import MeetTheTeamPage from "./pages/MeetTheTeamPage";
import NotFoundPage from "./pages/NotFoundPage";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Header />
          <main className="min-h-screen">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/services" element={<ServicesPage />} />
              <Route path="/services/deep-cleaning" element={<DeepCleaningPage />} />
              <Route path="/services/house-cleaning" element={<HouseCleaningPage />} />
              <Route path="/services/move-in-move-out-cleaning" element={<MoveInOutCleaningPage />} />
              <Route path="/services/vacation-rental-cleaning" element={<VacationRentalCleaningPage />} />
              <Route path="/services/commercial" element={<CommercialCleaningPage />} />
              <Route path="/services/commercial/office-cleaning" element={<OfficeCleaningPage />} />
              <Route path="/services/commercial/property-management" element={<PropertyManagementCleaningPage />} />
              <Route path="/services/commercial/real-estate-cleaning" element={<RealEstateCleaningPage />} />
              <Route path="/services/commercial/construction-cleanup" element={<PostConstructionCleaningPage />} />
              <Route path="/resources" element={<ResourcesHubPage />} />
              <Route path="/resources/deep-cleaning-guide" element={<DeepCleaningGuidePage />} />
              <Route path="/areas/palm-bay" element={<PalmBayPage />} />
              <Route path="/areas/melbourne" element={<MelbournePage />} />
              <Route path="/areas/viera" element={<VieraPage />} />
              <Route path="/areas/satellite-beach" element={<SatelliteBeachPage />} />
              <Route path="/areas/indialantic" element={<IndialanticPage />} />
              <Route path="/areas/indian-harbour-beach" element={<IndianHarbourBeachPage />} />
              <Route path="/areas/cocoa-beach" element={<CocoaBeachPage />} />
              <Route path="/areas/melbourne-beach" element={<MelbourneBeachPage />} />
              <Route path="/areas/rockledge" element={<RockledgePage />} />
              <Route path="/areas/cocoa" element={<CocoaPage />} />
              <Route path="/areas/merritt-island" element={<MerrittIslandPage />} />
              <Route path="/areas/west-melbourne" element={<WestMelbournePage />} />
              <Route path="/gallery" element={<GalleryPage />} />
              <Route path="/reviews" element={<ReviewsPage />} />
              <Route path="/why-choose-us" element={<WhyChoosePage />} />
              <Route path="/meet-the-team" element={<MeetTheTeamPage />} />
              <Route path="/faq" element={<FAQPage />} />
              <Route path="/contact" element={<ContactPage />} />
              
              {/* 404 Catch-All Route */}
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </main>
          <Footer />
          <Toaster position="top-right" />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
